<!--
    描述：开票记录
    时间：2020/12/2
    Created by zl
-->
<template>
	<div class="h100 invoice-setting">
	  <filter-layout
		@search="searchResult"
		@reset="reset"
		hasMore
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="120px"
			:model="searchForm"
		  >
			<el-form-item label="纳税人名称：" prop="tenantSname">
			  <el-input
				v-model="searchForm.tenantSname"
				placeholder="请输入纳税人名称"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="纳税人识别号：" prop="identifyNo">
			  <el-input
				v-model="searchForm.identifyNo"
				placeholder="请输入纳税人识别号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="银行账号：" prop="account">
			  <el-input
				v-model="searchForm.account"
				placeholder="请输入银行账号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="税控设备编号：" prop="deviceNo">
			  <el-input
				v-model="searchForm.deviceNo"
				placeholder="请输入税控设备编号"
				size="small"
			  ></el-input>
			</el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="120px"
			:model="searchForm"
		  >
			<el-form-item label="开票终端标识：" prop="tag">
			  <el-input
				v-model="searchForm.tag"
				placeholder="请输入开票终端标识"
				size="small"
			  ></el-input>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  合计开票信息设置：
			  <span class="blue">{{ tablePage.total }}</span> 条
			</div>
			<div class="mt10 mb10 fr">
			  <el-button
				type="primary"
				class="btn-blue ml10"
				icon="el-icon-refresh"
				@click="reset"
				size="small"
			  ></el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow" ref="table">
			  <vxe-table
				ref="xTable"
				auto-resize
				border
				size="small"
				:data="tableData"
				highlight-current-row
				highlight-hover-row
				height="100%"
				:loading="loading"
				show-overflow="tooltip"
				show-header-overflow="tooltip"
			  >
				<vxe-table-column
				  type="seq"
				  width="5%"
				  title="序号"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="tenantSname"
				  title="纳税人名称"
				  width="13%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="identifyNo"
				  title="纳税人识别号"
				  width="12%"
				  header-align="center"
				>
				</vxe-table-column>
				<vxe-table-column
				  field="address"
				  title="地址"
				  width="15%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bank"
				  title="开户行"
				  width="10%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="account"
				  title="银行账号"
				  width="10%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="deviceNo"
				  title="税控设备编号"
				  width="11%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="tag"
				  title="开票终端标识"
				  width="10%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="appKey"
				  title="Appkey"
				  width="10%"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column title="操作" min-width="235px" align="center">
				  <template v-slot="{ row }">
					<el-button
					  type="success"
					  round
					  plain
					  class="hidden table-btn"
					  v-if="roleBtns.includes('edit')"
					  @click="openDia('edit', row)"
					>
					  <svg-icon icon-class="form-edit"></svg-icon> 编辑
					</el-button>
					<!-- <span class="ml5 mr5 bgc hidden">|</span> -->
					<el-button
					  type="primary"
					  round
					  plain
					  class="table-btn"
					  v-if="roleBtns.includes('checkInfo')"
					  @click="openDia('view', row)"
					>
					  <svg-icon icon-class="form-look"></svg-icon> 查看
					</el-button>
					<!-- <span class="ml5 mr5 bgc">|</span> -->
					<el-button
					  type="danger"
					  round
					  plain
					  disabled
					  class="table-btn"
					  v-if="roleBtns.includes('delete')"
					  icon="el-icon-delete"
					  @click="doDelete(row)"
					  >删除
					</el-button>
				  </template>
				</vxe-table-column>
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="tablePage.currentPage"
				:page-size="tablePage.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tablePage.total"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="h100 invoice-setting operation-layout" v-else>
		<div class="content">
		  <el-form
			ref="addForm"
			:model="addForm"
			label-width="130px"
			:rules="addRules"
			size="small"
		  >
			<el-divider content-position="left">纳税人信息</el-divider>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="纳税人名称：" prop="tenantId">
				  <el-input
					v-model="addForm.sname"
					:disabled="isDisabled"
					size="small"
				  ></el-input>
				</el-form-item>
			  </el-col>
			  <el-col :span="11" :offset="1">
				<el-form-item label="纳税人识别号：" prop="identifyNo">
				  <el-input
					v-model="addForm.identifyNo"
					:disabled="isDisabled"
					placeholder="请输入纳税人识别号"
					maxlength="20"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="地址：" prop="address">
				  <el-input
					v-model="addForm.address"
					:disabled="isDisabled"
					placeholder="请输入地址"
					maxlength="80"
				  ></el-input>
				</el-form-item>
			  </el-col>
			  <el-col :span="11" :offset="1">
				<el-form-item label="电话：" prop="phone" :rules="phoneRule">
				  <el-input
					v-model="addForm.phone"
					:disabled="isDisabled"
					placeholder="请输入电话"
					maxlength="20"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-row>
			  <!-- <el-col :span="11">
						  <el-form-item label="业务类型："
										prop="appKey">
							  <el-input v-model="addForm.appKey"
										:disabled="isDisabled"
										placeholder="请输入业务类型"
										maxlength="100"></el-input>
						  </el-form-item>
					  </el-col> -->
			  <el-col :span="11">
				<el-form-item label="联系方式：" prop="contacts">
				  <el-input
					v-model="addForm.contacts"
					:disabled="isDisabled"
					placeholder="请输入邮箱或手机号"
					maxlength="30"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="开户行：" prop="bank">
				  <el-input
					v-model="addForm.bank"
					:disabled="isDisabled"
					placeholder="请输入开户行"
					maxlength="100"
				  ></el-input>
				</el-form-item>
			  </el-col>
			  <el-col :span="11" :offset="1">
				<el-form-item label="银行账号：" prop="account">
				  <el-input
					v-model="addForm.account"
					:disabled="isDisabled"
					placeholder="请输入银行账号"
					maxlength="30"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-divider content-position="left">设备</el-divider>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="税控设备编号：" prop="deviceNo">
				  <el-input
					v-model="addForm.deviceNo"
					:disabled="isDisabled"
					placeholder="请输入税控设备编号"
					maxlength="18"
				  ></el-input>
				</el-form-item>
			  </el-col>
			  <el-col :span="11" :offset="1">
				<el-form-item label="开票终端标识：">
				  <el-input
					v-model="addForm.tag"
					:disabled="isDisabled"
					placeholder="请输入开票终端标识"
					maxlength="50"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="appkey：" prop="appKey">
				  <el-input
					v-model="addForm.appKey"
					:disabled="isDisabled"
					placeholder="请输入appkey"
				  ></el-input>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-divider content-position="left">税率</el-divider>
			<el-row>
			  <el-col :span="11">
				<el-form-item label="纳税人类型：" prop="type">
				  <el-radio-group
					v-model="addForm.type"
					:disabled="isDisabled"
					@change="radioChange"
				  >
					<el-radio :label="1008001">一般纳税人</el-radio>
					<el-radio :label="1008002">小规模纳税人</el-radio>
				  </el-radio-group>
				</el-form-item>
			  </el-col>
			  <el-col :span="11" :offset="1">
				<el-form-item label="税档：" prop="taxFile">
				  <el-checkbox-group
					v-if="addForm.type == 1008001"
					v-model="addForm.taxFile"
					:disabled="isDisabled"
				  >
					<el-checkbox
					  v-for="(item, index) in normalTaxList"
					  :key="'taxFile' + index"
					  :label="item.value"
					  >{{ item.label }}</el-checkbox
					>
				  </el-checkbox-group>
				  <el-checkbox-group
					v-else
					v-model="addForm.taxFile"
					:disabled="isDisabled"
				  >
					<el-checkbox
					  v-for="(item, index) in smallTaxList"
					  :key="'taxFile' + index"
					  :label="item.value"
					  >{{ item.label }}</el-checkbox
					>
				  </el-checkbox-group>
				</el-form-item>
			  </el-col>
			</el-row>
			<el-divider content-position="left">经营范围</el-divider>
			<el-row>
			  <el-col :span="11">
				<el-form-item prop="busSope">
				  <el-tree
					ref="tree"
					:data="treeData"
					:disabled="isDisabled"
					:expand-on-click-node="false"
					:highlight-current="true"
					:props="defaultProps"
					node-key="value"
					default-expand-all
					:default-checked-keys="treeDefaultCheckedKey"
					show-checkbox
				  ></el-tree>
				</el-form-item>
			  </el-col>
			</el-row>
		  </el-form>
		</div>
		<div class="footer" :class="{ hidden: routeQuery }">
		  <el-button class="btn cancel-btn hidden" @click="goBack"
			>取消</el-button
		  >
		  <el-button
			v-if="!isDisabled"
			type="primary"
			class="btn btn-blue"
			@click="doSave(addForm.id)"
			>保存</el-button
		  >
		</div>
	  </div>
	</div>
  </template>
<script>
import {
	getBusScopeTreeList,
	getCascadeByValue,
	getInvoiceInfoById,
	getInvoiceInfoList,
	saveInvoiceInfo,
} from "api/modules/invoice";
import { mapState } from "vuex";

export default {
	name: 'Invoice-Setting',
	props: {},
	data() {
		let phoneReg = (rule, value, callback) => {
			// eslint-disable-next-line no-useless-escape
			let reg = /(^0\d{2,3}\-\d{7,8}$)|(^1[3|4|5|6|7|8][0-9]{9}$)/
			if (reg.test(value)) {
				callback()
			} else {
				return callback(new Error('格式不正确'))
			}
		}
		return {
			searchForm: {
				tenantSname: '', //纳税人名字
				identifyNo: '', //纳税人识别号
				account: '', //银行账号
				deviceNo: '', //税控设备编号
				tag: '', //开票终端标识
			},
			tableData: [],
			tablePage: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			// 新增弹框
			addForm: {
				tenantId: '', //纳税人id
				sname: '', //纳税人名称
				identifyNo: '', //纳税人识别号
				address: '', //地址
				phone: '', //电话
				bank: '', //开户行
				account: '', //银行账号
				contacts: '', // 联系方式
				appKey: '', //银行账号
				deviceNo: '', //税控设备编号
				tag: '', //开票终端标识
				type: 1008001, //纳税人类型
				taxFile: [], //税档
				busSope: [], //经营范围
			},
			// eslint-disable-next-line no-undef
			addRules: bmElementFormRules([
				{ keyName: 'tenantId', validatorName: 'required', tip: '' },
				{ keyName: 'identifyNo', validatorName: 'required', tip: '' },
				{ keyName: 'address', validatorName: 'required', tip: '' },
				{ keyName: 'bank', validatorName: 'required', tip: '' },
				{ keyName: 'account', validatorName: 'required', tip: '' },
				{ keyName: 'appKey', validatorName: 'required', tip: '' },
				{ keyName: 'deviceNo', validatorName: 'required', tip: '' },
				{ keyName: 'type', validatorName: 'select', tip: '' },
				{ keyName: 'taxFile', validatorName: 'select', tip: '' },
			]),
			phoneRule: [
				{ required: true, message: '不能为空', trigger: 'blur' },
				{ validator: phoneReg, trigger: 'blur' },
			],
			isDisabled: false,
			normalTaxList: [], //一般纳税人税档
			smallTaxList: [], //小规模纳税人税档
			treeData: [], // 经营范围数据
			defaultProps: {
				children: 'children',
				label: 'sname',
			},
			treeDefaultCheckedKey: [],
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('invoiceSet')) {
				this.searchForm = JSON.parse(this.$getSessionItem('invoiceSet'))
				this.tablePage.currentPage = JSON.parse(
					this.$getSessionItem('invoiceSet')
				).currentPage
				this.tablePage.pageSize = JSON.parse(
					this.$getSessionItem('invoiceSet')
				).pageSize
				this.$removeSessionItem('invoiceSet')
			}
		}

		this.getInvoiceInfoList()
		this.getCascadeByValue()
	},
	methods: {
		// 获取所有的开票信息
		getInvoiceInfoList() {
			this.loading = true
			let params = Object.assign({}, this.searchForm)
			params.current = this.tablePage.currentPage
			params.size = this.tablePage.pageSize
			getInvoiceInfoList(params)
				.then((d) => {
					if (d.operationCode == 1) {
						this.tableData = d.data.records
						this.tablePage.total = parseInt(d.data.total)
						this.loading = false
					}
				})
				.catch((error) => {
					this.loading = false
				})
		},

		// 获取所有税率
		getCascadeByValue() {
			getCascadeByValue({
				code: '1008',
			}).then((d) => {
				if (d.operationCode == 1) {
					this.smallTaxList = d.data[0].children
					this.normalTaxList = d.data[1].children
				}
			})
		},

		// 获取所有经营范围
		getBusScopeTreeList() {
			getBusScopeTreeList().then((d) => {
				if (d.operationCode == 1) {
					this.treeData = d.data
					if (this.isDisabled) {
						this.treeData.forEach((item) => {
							let children = item.children
							children.forEach((x) => {
								x.disabled = true
							})
							item.disabled = true
						})
					}
				}
			})
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tablePage.pageSize = size
			this.getInvoiceInfoList()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tablePage.currentPage = cur
			this.getInvoiceInfoList()
		},

		// 纳税人类型切换
		radioChange() {
			this.taxFile = []
			this.addForm.taxFile = []
		},

		// 搜索
		searchResult() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.getInvoiceInfoList()
		},

		// 重置
		reset() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.$refs.searchRef.resetFields()
			this.searchForm.tenantSname = ''
			this.searchForm.identifyNo = ''
			this.searchForm.account = ''
			this.searchForm.deviceNo = ''
			this.searchForm.tag = ''
			this.getInvoiceInfoList()
		},

		// 分页
		handlePageChange(data) {
			this.tablePage.currentPage = data.currentPage
			this.tablePage.pageSize = data.pageSize
			this.getInvoiceInfoList()
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 新增/编辑
		openDia(type, row) {
			let params = Object.assign({}, this.searchForm)
			params.pageSize = this.tablePage.pageSize
			params.currentPage = this.tablePage.currentPage

			// 存值
			this.$setSessionItem('invoiceSet', JSON.stringify(params))

			this.$router.push({
				path: '/invoice-setting',
				query: {
					type: type,
				},
			})
			this.isDisabled = false
			if (type == 'add') {
				this.addForm = {}
				this.$set(this.addForm, 'taxFile', [])
				this.$set(this.addForm, 'type', 1008001)
				this.treeDefaultCheckedKey = []
			} else if (type == 'edit') {
				this.getInvoiceInfoById(row)
			} else if (type == 'view') {
				this.isDisabled = true
				this.getInvoiceInfoById(row)
			}
			this.getBusScopeTreeList()
		},

		// 保存
		doSave() {
			if (this.addForm.taxFile.length < 1) {
				this.$message.error('请选择税率！')
			} else {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						let params = Object.assign({}, this.addForm)
						// 获取经营范围所有选中的，分割成字符串
						let res = this.$refs.tree.getCheckedNodes()
						let arr = []
						res.forEach((x) => {
							arr.push(x.value)
						})
						arr = arr.join(',')
						params.busSope = arr
						// 税率
						params.taxFile = params.taxFile.join(',')
						saveInvoiceInfo(params).then((d) => {
							if (d.operationCode == 1) {
								this.goBack()
								this.$message.success('操作完成')
								this.getInvoiceInfoList()
							}
						})
					}
				})
			}
		},

		// 删除
		doDelete(data) {
			this.$confirm('是否确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					saveInvoiceInfo({
						id: data.id,
						isFlag: 0,
					}).then((d) => {
						if (d.operationCode == 1) {
							this.getInvoiceInfoList()
							this.$message.success('删除成功')
						}
					})
				})
				.catch(() => {
					this.$message.info('已取消删除')
				})
		},

		// 根据id查询明细
		getInvoiceInfoById(row) {
			getInvoiceInfoById({
				id: row.id,
			}).then((d) => {
				if (d.operationCode == 1) {
					this.addForm = d.data
					this.addForm.type = parseInt(d.data.type)
					this.addForm.taxFile = d.data.taxFile.split(',')
					this.treeDefaultCheckedKey = d.data.busSope.split(',')
				}
			})
		},

		// 纳税人名称修改
		tenantChange(data) {
			this.addForm.sname = sname
		},

		// 返回
		goBack() {
			this.$router.push({ psth: '/invoice-setting' })
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', {
			isBack: (state) => state.isBack,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
	},
}
</script>
<style lang="less" scoped>
.invoice-setting {
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	.searchForm {
		border-bottom: 1px solid #2671cc;
	}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
	.btn-style {
		width: 80px;
		height: 32px;
	}

	.operation-header {
		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}
	/deep/ .vxe-cell--title {
		color: #202020;
		font-weight: normal;
	}
	.content {
		height: 100%;
		padding-bottom: 60px;
		overflow-y: auto;
	}
	.footer {
		position: absolute;
		bottom: 0;
		left: 0;
		box-sizing: border-box;
		border-top: 1px solid #eee;
		box-shadow: 0 -2px 1px #f3f3f3;
		width: 100%;
		height: 60px;
		padding: 10px 0;
		background: #fff;
		text-align: center;
		white-space: nowrap;
		z-index: 999;
	}
	.bgc {
		color: #d6d6d6;
	}
}
</style>
